module.exports = __webpack_public_path__ + "img/Walnut 960x1080.ea1127c3.png";